import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';

const faqData = [
  {
    question: '¿Cuánto cuesta la primera consulta?',
    answer:
      'La primera consulta tiene un valor de 1 Jus honorario, según el valor arancelario vigente fijado por el Colegio de Abogados (Ley 14.967). No es un monto arbitrario: es el honorario mínimo obligatorio que garantiza un análisis profesional de tu documentación, evaluación de viabilidad y planteo de estrategia inicial. Si decidimos avanzar juntos, ese valor se descuenta del presupuesto final que acordemos.',
  },
  {
    question: '¿Atienden de forma virtual o solo presencial?',
    answer:
      'Atendemos de ambas formas. Podés elegir reunirte por videollamada desde donde estés, o venir a nuestro estudio si preferís el trato cara a cara.',
  },
  {
    question: '¿En qué zonas atienden? ¿Trabajan en todo el país?',
    answer:
      'El estudio está en San Justo, pero atendemos casos de toda la Provincia de Buenos Aires y CABA. También llevamos casos en todo el país de forma virtual.',
  },
  {
    question: '¿Cuánto tarda un proceso de divorcio?',
    answer:
      'Depende de cada caso en concreto. En la primera consulta evaluamos tu situación particular y te damos una estimación realista de los plazos según la complejidad.',
  },
  {
    question: '¿Cuánto tarda una sucesión?',
    answer:
      "Una sucesión 'express' (sin conflictos) puede demorar entre 3 y 8 meses. Te explicamos cada paso para que no te tome por sorpresa y sepas siempre cómo avanza tu trámite.",
  },
  {
    question: '¿Cobran por porcentaje o por honorarios fijos?',
    answer:
      'Depende del caso. Definimos honorarios fijos o en cuotas según tu situación, siempre con transparencia y sin sorpresas de último momento.',
  },
  {
    question: '¿Atienden casos de violencia familiar o de género?',
    answer:
      'Sí, con total reserva, empatía y prioridad de atención. Te acompañamos en la denuncia, medidas cautelares y todos los pasos legales necesarios para que estés protegida.',
  },
  {
    question: '¿Qué documentación necesito traer a la primera consulta?',
    answer:
      'Solo tu DNI. Si tenés papeles relacionados al caso (contratos, partidas de nacimiento, partidas de defunción, cartas documento) podés traerlos, pero no es obligatorio. Lo importante es escucharte primero.',
  },
];

const FAQSection = ({
  items = faqData,
  title = 'Lo que más nos preguntan.',
  subtitle = 'Resolvé tus dudas más comunes antes de la primera consulta.'
}) => {
  return (
    <section className="faq-section" id="faq" data-testid="faq-section">
      <div className="faq-container">
        <p className="faq-eyebrow">PREGUNTAS FRECUENTES</p>
        <h2 className="faq-title">{title}</h2>
        <p className="faq-subtitle">{subtitle}</p>

        <Accordion type="single" collapsible className="faq-accordion">
          {items.map((item, index) => (
            <AccordionItem
              key={index}
              value={`faq-${index}`}
              className="faq-item"
              data-testid={`faq-item-${index}`}
            >
              <AccordionTrigger className="faq-question">
                {item.question}
              </AccordionTrigger>
              <AccordionContent className="faq-answer">
                {item.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FAQSection;
